<mat-card>{{'directChargeOrders' | translate}}</mat-card>



<div class="container" style="padding: 25px;">

    <mat-grid-list cols="6" rowHeight="50px">
        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard">
                <mat-label>{{'filter' | translate}}</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
            </mat-form-field>
        </mat-grid-tile>


        <mat-grid-tile colspan="2">
            <mat-form-field appearance="fill" class="example-form-field" style="margin: 10px;;">
                <mat-label>{{'status' | translate}}</mat-label>
                <mat-select [(value)]="selectedStatus" (selectionChange)="getDirectCharge()">
                    <mat-option *ngFor="let item of chargedStatus" [value]="item.id">
                        {{item.name | translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <button mat-raised-button color="primary" [disabled]="directChargeList.length == 0"
                (click)="exportAsXLSX()">
                <mat-icon>import_export</mat-icon>
                {{'exportExcel' | translate}}
            </button>
        </mat-grid-tile>

    </mat-grid-list>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="orderId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'orderNo' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.orderId}} </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'dateTime' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.dateTime}} </td>
            </ng-container>

            <ng-container matColumnDef="userFullName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'fullName' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.userFullName}} </td>
            </ng-container>

            <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'product' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.product}} </td>
            </ng-container>

            <ng-container ntainer matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'quantity' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.quantity}} </td>
            </ng-container>

            <ng-container ntainer matColumnDef="playerId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'playerId' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <!-- {{row.playerId}}  -->

<!-- asdasdasd -->
                    <button mat-stroked-button color="primary" (click)="copyPlayerId(row.playerId)"
                        *ngIf="row.playerId != '' && row.playerId != null">{{row.playerId}}</button>
                </td>
            </ng-container>

              <ng-container ntainer matColumnDef="playerName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'playerName' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.playerName}} </td>
            </ng-container>

            <ng-container matColumnDef="imageUrl">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'image' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <img src="{{row.imageUrl}}" alt="no image" width="80" style="cursor: pointer;"
                        (click)="viewImg(row.imageUrl)">
                </td>
            </ng-container>

            <ng-container ntainer matColumnDef="notes">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'notes' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.notes}} </td>
            </ng-container>

            <ng-container matColumnDef="view">
                <th mat-header-cell *matHeaderCellDef> {{'view' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="edit(row)">
                        <mat-icon>pageview</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'chargedDone' | translate}} </th>
                <td mat-cell *matCellDef="let row;let i = index;" style="width: 10%;padding: 10px;">
                    <button mat-raised-button color="primary" style="margin-bottom: 10px;background-color: green;"
                        *ngIf="row.status == 0 && !row.bytic" (click)="onChargedDone(row.id)">
                        <mat-icon>save</mat-icon>
                        {{'chargedDone' | translate}}
                    </button>

                    <button mat-raised-button color="primary" (click)="onReject(row.id)"
                        *ngIf="row.status == 0 && !row.bytic">
                        <mat-icon>call_missed</mat-icon>
                        {{'reject' | translate}}
                    </button>

                </td>
            </ng-container>

            <!-- <ng-container matColumnDef="reject" *ngIf="selectedMessageType != 2">
                <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'reject' | translate}} </th>
                <td mat-cell *matCellDef="let row;let i = index;" style="width: 10%;padding: 10px;">
                 
                </td>
            </ng-container> -->

            <!-- <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef> {{'delete' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="onDelete(row.id)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container> -->


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}} "{{input.value}}"</td>
            </tr>
        </table>

        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>

<ng-template #Modal>

    <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
    <div mat-dialog-content>
        <p>{{'areYouSureToDelete' | translate}}</p>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-button cdkFocusInitial>{{'yes' | translate}}</button>
    </div>

</ng-template>

<ng-template #ModalView>

    <h1 mat-dialog-title>{{'messageText' | translate}}</h1>
    <div mat-dialog-content>
        <!-- {{message_text}} -->
    </div>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close (click)="onNoClick()">Close</button>
    </div>

</ng-template>

<ng-template #ModalViewImg>

    <!-- <h1 mat-dialog-title>{{'messageText' | translate}}</h1> -->
    <div mat-dialog-content>
        <img src="{{imgView}}" alt="no image" width="100%" height="100%">
    </div>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close (click)="onNoClick()">Close</button>
    </div>

</ng-template>


<ng-template #ModalConfirmReject>

    <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
    <div mat-dialog-content>
        <p>{{'areYouSureToReject' | translate}}</p>
        <mat-form-field appearance="standard">
            <mat-label>{{'rejectReason' | translate}}</mat-label>
            <textarea matInput [(ngModel)]="rejectReason"></textarea>
        </mat-form-field>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-button cdkFocusInitial (click)="confirmReject()">{{'yes' | translate}}</button>
    </div>

</ng-template>